/**
 * Square mono citation badge for a user role.
 *
 * The role is a category address per §10, not a mastery state — so it
 * gets the mono-ink treatment, never a colored pill. Admin gets a
 * stronger border + ink so it pops out in admin/users rows.
 *
 * Pulled from /me and /admin/users which were copy-pasting the same
 * conditional className. Allows a size prop because /me uses a slightly
 * larger 11px badge while admin rows use 10px to fit row density.
 */

type RoleBadgeProps = {
  role: string;
  size?: "sm" | "md";
};

export function RoleBadge({ role, size = "sm" }: RoleBadgeProps) {
  const sizeClass = size === "md" ? "text-[11px]" : "text-[10px]";
  const toneClass =
    role === "admin"
      ? "border-ink-700 text-ink-900"
      : "border-ink-200 text-ink-500";
  return (
    <span
      className={`inline-block font-mono ${sizeClass} uppercase tracking-wide px-1.5 py-0.5 border ${toneClass}`}
    >
      {role}
    </span>
  );
}
